import { Component, Input, OnChanges} from '@angular/core';
import { Router, Params } from '@angular/router';
import { Location } from '@angular/common';
import { Product, ProductResponse } from '../../../../models/Product';
import { ProductService } from "../../../../services/product.service";
import { ProductValidatorService } from "../../../../services/validators/product-validator.service";
import { FormComponent } from "../../../../models/FormComponent";
import { FlashService } from '../../../../services/utility/flash.service';
// import { ApeSkuComponent } from '../../../admin/admin-products/admin-product-edit/ape-sku/ape-sku.component';

@Component({
  selector: 'app-admin-product-add',
  templateUrl: './admin-product-add.component.html',
  styleUrls: ['./admin-product-add.component.scss']
})
export class AdminProductAddComponent implements OnChanges {
  @Input('products') products:Product[];  //linked to parent 'admin-products', will initially be null until products are loaded.
  // @ViewChild('apeSku') apeSku:ApeSkuComponent;
  
  product:Product = null;

  constructor(
    private router:Router,
    private productService:ProductService,
    private validator:ProductValidatorService,
    private flashService:FlashService,
    private location: Location,
  ) { }

  ngOnChanges(){ 
    //template only shows 'add' form once 'new product' has been created here (not null).
    // waits until productService has loaded products before creating blank product (so that we can access known categories)

    //guard: products must first be received by parent
    if(this.product || !this.products || this.products.length == 0){
      return;
    }
    
    //products have been loaded
    //create a blank product object to hold form data
    this.product = this.productService.blankProduct()
  }


  onCancelClicked(){
    // console.log('cancel clicked');
    // flash message editing cancelled
    this.flashService.flashMessage.show('Cancelled \'add product\'.  Changes not saved.', {cssClass:'alert-danger', timeout: 4000});
    this.location.back();
  }


  onSubmit({value, valid}:{value:Product, valid:boolean}){
    //manually trigger validation for all fields
    let showErrorsAndAlerts = true;
    this.validator.triggerValidationsForAllFormComponents(showErrorsAndAlerts);

    //assemble the validation errors
    let validationErrors = this.validator.validationErrors();
    // let requiredOnly=true;
    let validationAlerts = this.validator.validationAlerts();
    console.log('validationAlerts', validationAlerts);
    //show error message
    if(validationErrors.length > 0 || validationAlerts.length > 0){
      // issues exist
      let issueCount = validationErrors.length+validationAlerts.length;
      let msg = 'Unable to add product ('+issueCount+' issues).';
      this.flashService.flashMessage.show(msg, {cssClass:'alert-danger', timeout: 4000});
    } else { 
      //Add Product (no issues)
      this.productService.addProduct(this.product).first().subscribe((productResponse:ProductResponse) => {
      console.log('pce: res', productResponse);
      if(productResponse.success){
        let addedProduct = productResponse.product;
        this.flashService.flashMessage.show('Successfully saved edits to product.', {cssClass:'alert-success', timeout:4000});
        //also, register the product to show 'saved' on the product-list table
        let flashService = this.flashService;
        setTimeout(function() {
          // console.log('productResponse.product', editedProduct);
          let elementId = '#flashSaved'+addedProduct.sku;
          // console.log('flashing element', element);
          flashService.flashElementWithId(elementId, 'Added', 4000);
        }, 0);

        this.router.navigate(['/admin/products']);
      } else {
        //flashmessage error
        console.log('pce: error editing product');
        this.flashService.flashMessage.show(productResponse.msg, {cssClass:'alert-danger', timeout:4000});
      }

    })

      
    }
  }


}




//===============
//Unused Code


// let element = $('#flashSkuAvailable');
// console.log('flashing element', element);

// let elementId = '#flashSkuAvailable';  //must contain the hash
// this.flashService.flashElementWithId(elementId, 'Available1', 4000000);


// let elementId = '#flashSkuTaken';  //must contain the hash
      // let flashService = this.flashService;
      // setTimeout( () => {
      //   this.flashService.flashElementWithId(elementId, 'Sku Already Taken', 4000);
      // }, 0);
      // flashService.flashElementWithId(elementId, 'Saved', 4000);  //see ap-list.  This was in a setTimeout with count 0.
// console.log('products', this.products);


//the form is in the component, not here.  So value/valid basically refer to an empty form.
// console.log('value', value);
// console.log('valid', valid);

// console.log('this.apeSku', this.apeSku);
// console.log('this.apeSku.productSku', this.apeSku.form);
// let ps = this.apeSku.form;
// console.log('form.errors', ps.errors);
// console.log('form.valid', ps.valid);
// console.log('form.value', ps.value);

//1 - validations will only occur upon field being touched.
//  So either touch them all, or trigger their 'onchange'.



// if(this.disableBalanceOnAdd){
//   value.balance = 0;
// }

// if(!valid){
//   this.flashMessagesService.show('Please fill in all fields', {cssClass:'alert-danger', timeout:4000});
//   this.router.navigate(['add-client']);
// } else {
//   //Add new client to firebase
//   this.clientService.newClient(value);
//   this.flashMessagesService.show('New client added', {cssClass:'alert-success', timeout:4000});
//   this.router.navigate(['/']);
// }

// this.apeSku.triggerValidationsforParent(showErrorsAndAlerts);
    // this.apeCategory.triggerValidationsforParent(showErrorsAndAlerts);

  // console.log('validation errors', validationErrors);
    // console.log('validation alerts', validationAlerts);

      // console.log('this.validator.formComponents', this.validator.formComponents);

      // //hide alert for field if value was blank and not required
      // console.log('1 - vas', formComponent.validationAlertSettings);
      // let required = formComponent.validationAlertSettings.required;
      // console.log('2');
      // let fieldIsBlank = (formComponent.fieldValue==undefined || formComponent.fieldValue==='');
      // if(!required && fieldIsBlank){
      //   formComponent.hideAlertView();
      // }


// WEBPACK FOOTER //
// ./src/app/components/admin/admin-products/admin-product-add/admin-product-add.component.ts